import { Grid } from '@simplywallst/ui-core';
import { Bones } from '@simplywallst/ui-core';
import { TileColumn } from './styled';
import { TileRow, TileViewContainer } from '@/components/TileView';

const TileSkeleton = ({ numberOfItems = 4 }: { numberOfItems?: number }) => (
  <TileViewContainer>
    <TileRow>
      {Array.from({ length: numberOfItems }, (_, index) => (
        <TileColumn col={6} colSm={4} colLg={3} key={index}>
          <Grid rowGap="16px">
            <Bones maxWidth="100%" minHeight="160px" />
            <Grid rowGap="8px">
              <Bones maxWidth="100%" minHeight="32px" />
              <Grid rowGap="8px">
                <Bones maxWidth="100%" />
                <Bones maxWidth="100%" />
                <Bones maxWidth="100%" />
              </Grid>
            </Grid>
            <Bones maxWidth="100%" maxHeight="0px" />
          </Grid>
        </TileColumn>
      ))}
    </TileRow>
  </TileViewContainer>
);

export { TileSkeleton };
